export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.dev.json',
};
